import React from 'react'
import { useTheme } from '@material-ui/core/styles'
import SpinnerDesignComponent from 'spinner'

/**
 * Spinner to be used for consistency throughout the number picker.
 */
const Spinner = (): JSX.Element => {
    const theme = useTheme()

    return (
        <SpinnerDesignComponent size="sm" color={theme.palette.primary.main} />
    )
}

export default Spinner
